import { fromJS } from 'immutable';
import { get, flatten } from 'lodash';
import * as actions from './actions';


import { sliceReducer } from '../../lib/reducers';
import urlReducer from './slice.reducer';

const actionTypes = flatten(
  Object
    .values(actions)
    .map(action => [
      action.REQUEST,
      action.SUCCESS,
      action.INTENT,
      action.FAILURE,
    ]),
);

const initialState = fromJS({
  urls: {},
});

export default function reducer(state = initialState, action) {
  if (!get(action, ['payload', 'url'])) {
    return state;
  }

  if (!actionTypes.includes(action.type)) {
    return state;
  }

  return sliceReducer(['urls', action.payload.url], urlReducer)(state, action);
}
